import React, { ComponentType, useEffect } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";

import { LoadingLayout } from "@/components/layouts";
import { checkPermission } from "@/utils";
import { useLocation, useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
  component: ComponentType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component }) => {

  const { isAuthenticated, isLoading, user } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();

  const client = process.env.REACT_APP_CLIENT || 'core';

  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <LoadingLayout />,
  });

  // Wait for a session
  if (isLoading ) return <LoadingLayout />

  // Not logged in, pass to the main component that will redirect to the login page
  if (!isAuthenticated) return <Component />

  // Logged in but no user, we still have to wait a bit
  if (!user) return <LoadingLayout />

  // Now we have a user, let's check their permissions
  if (
    user
    && !checkPermission(user, `user:${client}`)
    && !location.pathname.startsWith("/unauthorized")
  ) {
    navigate("unauthorized");
  }

  return <Component />;
};

export default ProtectedRoute;
